import bizNodeModel from '../../bizNodeModel.mjs'
import SrcType from '../components/SrcType.mjs'
import UeType from './UeType.mjs'

export default bizNodeModel({
    srcType: {
        name: () => '来源类型',

        readableValue: (map, node) => {
            const {srcType} = node.data

            if (srcType) {
                const match = SrcType.find(e => srcType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },
    },

    ueName: {
        name: () => '事件能力名称',
    },

    ueTypeCode: {
        name: () => '事件能力类型',

        readableValue: (map, node) => {
            const {useTypeCode} = node.data

            if (useTypeCode) {
                const match = UeType.find(e => useTypeCode === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },
    },

    ueUserCode: {
        name: () => '事件能力代码',
    },
})
